import { useMonitor } from "@suse-o11y/signal";
import React from "react";

import { FormLabel } from "~/components/form/label";
import { FormFieldReset } from "~/components/form/reset";
import { Switch } from "~/components/switch";

import { Widget, WidgetBody, WidgetHeader } from "../../../_widget";
import { WidgetLegendMode, WidgetLegendPosition, WidgetLegendTable } from "../../../widget-form/legend";
import type { FormState } from "../../../widget-form/legend/form-state";
import { SettingsSectionFormField } from "../_field";
import { SettingsSectionGrid } from "../_section-grid";

export interface LegendProps {
	legend: FormState;
}

export const Legend: React.FC<LegendProps> = ({ legend }) => {
	const monitor = useMonitor();

	const enabled = legend.enabled.getInput(monitor);
	const activeMode = legend.element.fields.mode.getActiveBranch(monitor);

	return (
		<Widget>
			<WidgetHeader className="grid-cols-[auto_auto_1fr] uppercase" title="Legend">
				<Switch
					checked={enabled}
					name="dashboard-widget-legend-show"
					onCheckedChange={(show) => legend.enabled.setInput(show)}
				/>

				<FormFieldReset className="ml-auto" state={legend} />
			</WidgetHeader>

			<WidgetBody card>
				<SettingsSectionGrid className="grid-cols-[auto_1fr]">
					<SettingsSectionFormField layout="horizontal" state={legend.element.fields.position}>
						<FormLabel>Position</FormLabel>
						<WidgetLegendPosition
							disabled={!enabled}
							name="dashboard-widget-legend-position"
							position={legend.element.fields.position}
						/>
					</SettingsSectionFormField>

					<SettingsSectionFormField layout="horizontal" state={legend.element.fields.mode.active}>
						<FormLabel>Mode</FormLabel>
						<WidgetLegendMode
							disabled={!enabled}
							mode={legend.element.fields.mode.active}
							name="dashboard-widget-legend-mode"
						/>
					</SettingsSectionFormField>

					{activeMode?.kind === "table" && (
						<SettingsSectionFormField layout="horizontal" state={activeMode.value}>
							<FormLabel>Values</FormLabel>
							<WidgetLegendTable disabled={!enabled} table={activeMode.value} />
						</SettingsSectionFormField>
					)}
				</SettingsSectionGrid>
			</WidgetBody>
		</Widget>
	);
};
